export enum typeUserData {
  admin = "Facom Admin",
  distributor = "Facom distributor",
  afterSales = "Facom Aftersales",
  group = "Facom Group",
  client = "Facom Client",
}
